import { Comment } from "./comments/types";
import { useLead } from "@/hooks/useLead";
import { useAuth } from "@/hooks/useAuth";
import { CommentsSection } from "../components/CommentsSection";

interface LeadCommentsProps {
  comments?: Comment[];
  leadId: string;
  userComment?: string | null; // Customer comment from valuation form
  leadCreatedAt?: string; // Lead creation timestamp for user comment
}

export const LeadComments = ({ comments = [], leadId, userComment, leadCreatedAt }: LeadCommentsProps) => {
  const { addCommentAsync, isAddingComment, updateCommentAsync, deleteCommentAsync } = useLead();
  const { user } = useAuth();

  const handleSubmitComment = async (
    text: string,
    isPublic: boolean,
    mentions: string[]
  ) => {
    // Get author name from user - combine firstName and lastName, fallback to email
    const authorName = user
      ? `${user.firstName || ""} ${user.lastName || ""}`.trim() || user.email
      : "Unknown User";

    await addCommentAsync({
      leadId: leadId,
      comment: {
        text,
        author: authorName,
        mentions,
      },
    });
  };

  // Prepare customer comment if available
  // Use lead creation date as timestamp for the customer comment
  const customerComment = userComment ? {
    text: userComment,
    timestamp: leadCreatedAt 
      ? (typeof leadCreatedAt === 'string' ? new Date(leadCreatedAt) : leadCreatedAt)
      : new Date(),
  } : undefined;

  return (
    <CommentsSection
      comments={comments}
      onSubmitComment={handleSubmitComment}
      onUpdateComment={(commentId, newText) =>
        updateCommentAsync({ leadId, commentId, text: newText })
      }
      onDeleteComment={(commentId) => deleteCommentAsync({ leadId, commentId })}
      isSubmitting={isAddingComment}
      customerComment={customerComment}
    />
  );
};
